// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--E2uu_","desc":"styles-module--desc--362s4","cards":"styles-module--cards--pJRub","card":"styles-module--card--2MWMD"};